import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ModelConfigs, ModelConfigsValues, ModerationFiltersState } from './moderationFiltersTypes';

const initialState: ModerationFiltersState = {
  isFetched: false,
  models: {},
  dataScienceModelMap: {}
};

const moderationFiltersSlice = createSlice({
  name: 'moderationFilters',
  initialState,
  reducers: {
    setModerationFilters(state, action: PayloadAction<ModelConfigs>) {
      state.isFetched = true;
      state.models = action.payload;
    },
    setDataScienceModelMap(state, action: PayloadAction<Record<string, string>>) {
      state.dataScienceModelMap = action.payload;
    },
    updateModerationFilters(state, action: PayloadAction<ModelConfigsValues>) {
      const models = state.models;
      const values = action.payload;

      Object.keys(models).forEach(key => {
        models[key].value = values[key] || null;
      });

      state.models = models;
    }
  }
});

export const moderationFiltersReducer = moderationFiltersSlice.reducer;

export const moderationFiltersActions = moderationFiltersSlice.actions;

export const {
  setModerationFilters,
  updateModerationFilters,
  setDataScienceModelMap
} = moderationFiltersActions;
